/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funke_Tv_Digital_Participation_Terms_DescriptionInputs */

const de_funke_tv_digital_participation_terms_description = /** @type {(inputs: Funke_Tv_Digital_Participation_Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmebedingungen für die Aktion "10 kostenlose Ausgaben der TV-Digital XXL".`)
};

/** @type {(inputs: Funke_Tv_Digital_Participation_Terms_DescriptionInputs) => LocalizedString} */
const en_funke_tv_digital_participation_terms_description = de_funke_tv_digital_participation_terms_description;

/**

* @param {Funke_Tv_Digital_Participation_Terms_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const funke_tv_digital_participation_terms_description = /** @type {((inputs?: Funke_Tv_Digital_Participation_Terms_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funke_Tv_Digital_Participation_Terms_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_funke_tv_digital_participation_terms_description(inputs)
	return en_funke_tv_digital_participation_terms_description(inputs)
});